import React, { Component } from "react";
import "./ConfirmOpenTicket.css";
import "react-overlay-loader/styles.css";
import FetchItineraries from "../components/confirmOpenTicketComponents/FetchItineraries";
import SearchReservation from "../components/confirmOpenTicketComponents/SearchReservation";
import ReservationDetails from "../components/confirmOpenTicketComponents/ReservationDetails";
import VoucherDisplay from "../components/confirmOpenTicketComponents/VoucherDisplay";
import VoucherConfirm from "../components/confirmOpenTicketComponents/VoucherConfirm";
import { Loader } from "react-overlay-loader";
import axios from "axios";
import moment from "moment";
import { ToastContainer, ToastStore } from "react-toasts";
import { translations } from "./assets/translations";
import { B2B_PROXY } from "./assets/config";

export default class ConfirmOpenTickets extends Component {
  constructor(props) {
    super(props);
    this.handleClickOnItinerary = this.handleClickOnItinerary.bind(this);
    this.fetchReservation = this.fetchReservation.bind(this);
    this.handleChangeOfDate = this.handleChangeOfDate.bind(this);
    this.myRef = React.createRef();
    this.jumpToTop = React.createRef();
    this.toggleCalendar = this.toggleCalendar.bind(this);
    this.handleClickOnItinerary = this.handleClickOnItinerary.bind(this);
    this.confirmOpenTickets = this.confirmOpenTickets.bind(this);
    this.issueBoardingPasses = this.issueBoardingPasses.bind(this);
    this.issueBoardingPassesAndConfirmOpenTickets = this.issueBoardingPassesAndConfirmOpenTickets.bind(
      this
    );
    this.cancelOpenTickets = this.cancelOpenTickets.bind(this);
    this.changeTrip = this.changeTrip.bind(this);
    this.goBackToFirstScreen = this.goBackToFirstScreen.bind(this);
    this.handleChangeOfCompany = this.handleChangeOfCompany.bind(this);
    this.handleChangeOfInputSearchFields = this.handleChangeOfInputSearchFields.bind(
      this
    );
    this.handlePersonCheckboxChange = this.handlePersonCheckboxChange.bind(
      this
    );
    this.handleVehicleCheckboxChange = this.handleVehicleCheckboxChange.bind(
      this
    );
    this.handlePersonSelectAllButton = this.handlePersonSelectAllButton.bind(
      this
    );
    this.handleVehicleSelectAllButton = this.handleVehicleSelectAllButton.bind(
      this
    );
    this.handleChangeOfInputTicketEmail = this.handleChangeOfInputTicketEmail.bind(
      this
    );
    this.handleChangeOfInputTicketPhone = this.handleChangeOfInputTicketPhone.bind(
      this
    );
    this.handleChangeOfInputTicketVehicleEmail = this.handleChangeOfInputTicketVehicleEmail.bind(
      this
    );
    this.handleChangeOfInputTicketVehiclePhone = this.handleChangeOfInputTicketVehiclePhone.bind(
      this
    );
    this.state = {
      companies: [
        ["AML", "AML"],
        ["INTERSHIPPING", "INTS"],
        ["FRS", "FRS"],
        ["IMTC", "IMTC"],
        ["TRANSMEDITERRANEA", "ACC"],
        ["BALEARIA", "BALE"]
      ],
      itineraries: [],
      personTickets: [],
      vehicleTickets: [],
      selectedPersonTickets: [],
      selectedVehicleTickets: [],
      ticketEmails: [],
      ticketPhoneNumbers: [],
      ticketVehicleEmails: [],
      ticketVehiclePhoneNumbers: [],
      vouchers: [],
      boardingCardVouchers: [],
      tripDataPerson: [],
      tripDataVehicle: [],
      confirmationPDFArray: [],
      shouldResDetailsUpdate: false,
      displayVouchers: false,
      displayVouchersConfirmed: false,
      displayReservationResults: false,
      displayItineraries: false,
      isPersonSelectAllToggled: false,
      isVehicleSelectAllToggled: false,
      showSearchContainer: true,
      loadingSpinner: false,
      disableSearchReservationButton: true,
      disableIssueBoardingPassesButton: true,
      isCalendarOpen: false,
      userHasInsertedAllData: false,
      hasCancelledTickets: false,
      hasPersonVouchers: false,
      selectedItineraryIndex: null,
      firstNewTicketIndex: null,
      isMRZMandatory: "0",
      lang: this.props.lang,
      date: moment(new Date()),
      selectedItineraryID: "",
      selectedSailID: "",
      reservationNumber: "",
      ticketNumber: "",
      companyDescription: "",
      companyAbbreviation: "",
      credentials: {
        userGroupCode: localStorage.getItem("userid"),
        code: localStorage.getItem("UserName"),
        password: localStorage.getItem("Password"),
        lang: "EN"
      }
    };
  }

  componentDidMount() {
    if (
      localStorage.getItem("Authenticated") === "false" ||
      localStorage.getItem("Authenticated") === null
    ) {
      this.props.history.push("/");
    } else {
      this.props.userHasAuthenticated();
    }
    axios
      .post(B2B_PROXY + "/CompaniesIndex", { credentials: this.state.credentials })
      .then(res => {
        const companies = res.data.map(obj => ({
          Code: obj.Code,
          Name: obj.Name
        }));
        this.setState({ companies });
      });
  }

  handleChangeOfDate(date) {
    this.setState({
      date: date
    });
    this.toggleCalendar();
  }

  toggleCalendar(e) {
    e && e.preventDefault();
    this.setState({ isCalendarOpen: !this.state.isCalendarOpen });
  }

  handleClickOnItinerary = (e, index) => {
    let selectedItineraryArray = e.target.id.split("@");
    this.setState({ selectedItineraryID: selectedItineraryArray[0] });
    this.setState({ selectedSailID: selectedItineraryArray[1] });
    this.setState({ companyAbbreviation: selectedItineraryArray[2] });
    this.setState({ selectedItineraryIndex: index });
    if (this.state.userHasInsertedAllData) {
      this.setState({ disableIssueBoardingPassesButton: false });
    }
  };

  handleChangeOfInputSearchFields(event) {
    let fieldName = event.target.name;
    let fieldValue = event.target.value;
    this.setState({ [fieldName]: fieldValue }, () => {
      let reservationNumberLength = this.state.reservationNumber.length;
      let ticketNumberLength = this.state.ticketNumber.length;
      if (
        reservationNumberLength > 2 ||
        (ticketNumberLength > 2)
      ) {
        if (this.state.companyAbbreviation !== "")
          this.setState({ disableSearchReservationButton: false });
      } else {
        this.setState({ disableSearchReservationButton: true });
      }
    });
  }

  handleChangeOfCompany = (companyDescription, companyAbbreviation) => {
    this.setState({ companyDescription: companyDescription });
    this.setState({ companyAbbreviation: companyAbbreviation }, () => {
      let reservationNumberLength = this.state.reservationNumber.length;
      let ticketNumberLength = this.state.ticketNumber.length;
      if (
        reservationNumberLength > 2 ||
        (ticketNumberLength > 2)
      ) {
        if (this.state.companyAbbreviation !== "")
          this.setState({ disableSearchReservationButton: false });
      } else {
        this.setState({ disableSearchReservationButton: true });
      }
    });
  };

  handleChangeOfInputTicketEmail(event, index) {
    let ticketEmails = [...this.state.ticketEmails];
    let ticketVehicleEmails = [...this.state.ticketVehicleEmails];
    let item = { ...ticketEmails[index] };
    item = event.target.value;
    if (index === this.state.firstNewTicketIndex) {
      for (let i = 0; i < this.state.ticketEmails.length; i++) {
        if (this.state.personTickets[i].ConfirmationStatus !== "Canceled")
          ticketEmails[i] = item;
      }
      if (this.state.vehicleTickets.length > 0)
        for (let i = 0; i < this.state.ticketVehicleEmails.length; i++) {
          if (this.state.vehicleTickets[i].ConfirmationStatus !== "Canceled")
            ticketVehicleEmails[i] = item;
        }
    }
    ticketEmails[index] = item;
    this.setState({ ticketVehicleEmails });
    this.setState({ ticketEmails }, () => {
      let hasSelectedPersons = false;
      let shouldNotIssueBoardingPassesFlag1 = false;
      for (let i = 0; i < this.state.selectedPersonTickets.length; i++) {
        if (this.state.selectedPersonTickets[i] === true) {
          hasSelectedPersons = true;
          if (
            (this.state.ticketEmails[i] === "" &&
              this.state.ticketPhoneNumbers[i] === "") ||
            ((this.state.ticketEmails[i].length > 0 &&
              !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                this.state.ticketEmails[i]
              )) ||
              (this.state.ticketPhoneNumbers[i].length > 0 &&
                this.state.ticketPhoneNumbers[i].length < 10))
          )
            shouldNotIssueBoardingPassesFlag1 = true;
        }
      }
      let shouldNotIssueBoardingPassesFlag2 = false;
      let hasSelectedVehicles = false;
      for (let i = 0; i < this.state.selectedVehicleTickets.length; i++) {
        if (this.state.selectedVehicleTickets[i] === true) {
          hasSelectedVehicles = true;
          if (
            (this.state.ticketVehicleEmails[i] === "" &&
              this.state.ticketVehiclePhoneNumbers[i] === "") ||
            ((this.state.ticketVehicleEmails[i].length > 0 &&
              !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                this.state.ticketVehicleEmails[i]
              )) ||
              (this.state.ticketVehiclePhoneNumbers[i].length > 0 &&
                this.state.ticketVehiclePhoneNumbers[i].length < 10))
          )
            shouldNotIssueBoardingPassesFlag2 = true;
        }
      }

      if (hasSelectedPersons) {
        if (!shouldNotIssueBoardingPassesFlag1) {
          if (hasSelectedVehicles) {
            if (!shouldNotIssueBoardingPassesFlag2) {
              this.setState({ userHasInsertedAllData: true });
              if (this.state.selectedItineraryID !== "")
                this.setState({ disableIssueBoardingPassesButton: false });
            } else {
              this.setState({ disableIssueBoardingPassesButton: true });
            }
          } else {
            this.setState({ userHasInsertedAllData: true });
            if (this.state.selectedItineraryID !== "")
              this.setState({ disableIssueBoardingPassesButton: false });
          }
        } else {
          this.setState({ disableIssueBoardingPassesButton: true });
        }
      } else if (hasSelectedVehicles) {
        if (!shouldNotIssueBoardingPassesFlag2) {
          if (hasSelectedPersons) {
            if (!shouldNotIssueBoardingPassesFlag1) {
              this.setState({ userHasInsertedAllData: true });
              if (this.state.selectedItineraryID !== "")
                this.setState({ disableIssueBoardingPassesButton: false });
            } else {
              this.setState({ disableIssueBoardingPassesButton: true });
            }
          } else {
            this.setState({ userHasInsertedAllData: true });
            if (this.state.selectedItineraryID !== "")
              this.setState({ disableIssueBoardingPassesButton: false });
          }
        } else {
          this.setState({ disableIssueBoardingPassesButton: true });
        }
      } else {
        this.setState({ disableIssueBoardingPassesButton: true });
      }
    });
  }

  handleChangeOfInputTicketPhone(event, index) {
    let ticketPhoneNumbers = [...this.state.ticketPhoneNumbers];
    let ticketVehiclePhoneNumbers = [...this.state.ticketVehiclePhoneNumbers];
    let item = { ...ticketPhoneNumbers[index] };
    item = event.target.value;
    if (/^[0-9\b]+$/.test(item) || item.length === 0) {
      ticketPhoneNumbers[index] = item;
      if (index === this.state.firstNewTicketIndex) {
        for (let i = 0; i < this.state.ticketPhoneNumbers.length; i++) {
          if (this.state.personTickets[i].ConfirmationStatus !== "Canceled")
            ticketPhoneNumbers[i] = item;
        }

        if (this.state.vehicleTickets.length > 0)
          for (
            let i = 0;
            i < this.state.ticketVehiclePhoneNumbers.length;
            i++
          ) {
            if (this.state.vehicleTickets[i].ConfirmationStatus !== "Canceled")
              ticketVehiclePhoneNumbers[i] = item;
          }
      }
    }
    this.setState({ ticketVehiclePhoneNumbers });
    this.setState({ ticketPhoneNumbers }, () => {
      let hasSelectedPersons = false;
      let shouldNotIssueBoardingPassesFlag1 = false;
      for (let i = 0; i < this.state.selectedPersonTickets.length; i++) {
        if (this.state.selectedPersonTickets[i] === true) {
          hasSelectedPersons = true;
          if (
            (this.state.ticketEmails[i] === "" &&
              this.state.ticketPhoneNumbers[i] === "") ||
            ((this.state.ticketEmails[i].length > 0 &&
              !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                this.state.ticketEmails[i]
              )) ||
              (this.state.ticketPhoneNumbers[i].length > 0 &&
                this.state.ticketPhoneNumbers[i].length < 10))
          )
            shouldNotIssueBoardingPassesFlag1 = true;
        }
      }
      let shouldNotIssueBoardingPassesFlag2 = false;
      let hasSelectedVehicles = false;
      for (let i = 0; i < this.state.selectedVehicleTickets.length; i++) {
        if (this.state.selectedVehicleTickets[i] === true) {
          hasSelectedVehicles = true;
          if (
            (this.state.ticketVehicleEmails[i] === "" &&
              this.state.ticketVehiclePhoneNumbers[i] === "") ||
            ((this.state.ticketVehicleEmails[i].length > 0 &&
              !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                this.state.ticketVehicleEmails[i]
              )) ||
              (this.state.ticketVehiclePhoneNumbers[i].length > 0 &&
                this.state.ticketVehiclePhoneNumbers[i].length < 10))
          )
            shouldNotIssueBoardingPassesFlag2 = true;
        }
      }

      if (hasSelectedPersons) {
        if (!shouldNotIssueBoardingPassesFlag1) {
          if (hasSelectedVehicles) {
            if (!shouldNotIssueBoardingPassesFlag2) {
              this.setState({ userHasInsertedAllData: true });
              if (this.state.selectedItineraryID !== "")
                this.setState({ disableIssueBoardingPassesButton: false });
            } else {
              this.setState({ disableIssueBoardingPassesButton: true });
            }
          } else {
            this.setState({ userHasInsertedAllData: true });
            if (this.state.selectedItineraryID !== "")
              this.setState({ disableIssueBoardingPassesButton: false });
          }
        } else {
          this.setState({ disableIssueBoardingPassesButton: true });
        }
      } else if (hasSelectedVehicles) {
        if (!shouldNotIssueBoardingPassesFlag2) {
          if (hasSelectedPersons) {
            if (!shouldNotIssueBoardingPassesFlag1) {
              this.setState({ userHasInsertedAllData: true });
              if (this.state.selectedItineraryID !== "")
                this.setState({ disableIssueBoardingPassesButton: false });
            } else {
              this.setState({ disableIssueBoardingPassesButton: true });
            }
          } else {
            this.setState({ userHasInsertedAllData: true });
            if (this.state.selectedItineraryID !== "")
              this.setState({ disableIssueBoardingPassesButton: false });
          }
        } else {
          this.setState({ disableIssueBoardingPassesButton: true });
        }
      } else {
        this.setState({ disableIssueBoardingPassesButton: true });
      }
    });
  }

  handleChangeOfInputTicketVehicleEmail(event, index) {
    let ticketVehicleEmails = [...this.state.ticketVehicleEmails];
    let item = { ...ticketVehicleEmails[index] };
    item = event.target.value;
    ticketVehicleEmails[index] = item;
    this.setState({ ticketVehicleEmails }, () => {
      let hasSelectedPersons = false;
      let shouldNotIssueBoardingPassesFlag1 = false;
      for (let i = 0; i < this.state.selectedPersonTickets.length; i++) {
        if (this.state.selectedPersonTickets[i] === true) {
          hasSelectedPersons = true;
          if (
            (this.state.ticketEmails[i] === "" &&
              this.state.ticketPhoneNumbers[i] === "") ||
            ((this.state.ticketEmails[i].length > 0 &&
              !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                this.state.ticketEmails[i]
              )) ||
              (this.state.ticketPhoneNumbers[i].length > 0 &&
                this.state.ticketPhoneNumbers[i].length < 10))
          )
            shouldNotIssueBoardingPassesFlag1 = true;
        }
      }
      let shouldNotIssueBoardingPassesFlag2 = false;
      let hasSelectedVehicles = false;
      for (let i = 0; i < this.state.selectedVehicleTickets.length; i++) {
        if (this.state.selectedVehicleTickets[i] === true) {
          hasSelectedVehicles = true;
          if (
            (this.state.ticketVehicleEmails[i] === "" &&
              this.state.ticketVehiclePhoneNumbers[i] === "") ||
            ((this.state.ticketVehicleEmails[i].length > 0 &&
              !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                this.state.ticketVehicleEmails[i]
              )) ||
              (this.state.ticketVehiclePhoneNumbers[i].length > 0 &&
                this.state.ticketVehiclePhoneNumbers[i].length < 10))
          )
            shouldNotIssueBoardingPassesFlag2 = true;
        }
      }

      if (hasSelectedPersons) {
        if (!shouldNotIssueBoardingPassesFlag1) {
          if (hasSelectedVehicles) {
            if (!shouldNotIssueBoardingPassesFlag2) {
              this.setState({ userHasInsertedAllData: true });
              if (this.state.selectedItineraryID !== "")
                this.setState({ disableIssueBoardingPassesButton: false });
            } else {
              this.setState({ disableIssueBoardingPassesButton: true });
            }
          } else {
            this.setState({ userHasInsertedAllData: true });
            if (this.state.selectedItineraryID !== "")
              this.setState({ disableIssueBoardingPassesButton: false });
          }
        } else {
          this.setState({ disableIssueBoardingPassesButton: true });
        }
      } else if (hasSelectedVehicles) {
        if (!shouldNotIssueBoardingPassesFlag2) {
          if (hasSelectedPersons) {
            if (!shouldNotIssueBoardingPassesFlag1) {
              this.setState({ userHasInsertedAllData: true });
              if (this.state.selectedItineraryID !== "")
                this.setState({ disableIssueBoardingPassesButton: false });
            } else {
              this.setState({ disableIssueBoardingPassesButton: true });
            }
          } else {
            this.setState({ userHasInsertedAllData: true });
            if (this.state.selectedItineraryID !== "")
              this.setState({ disableIssueBoardingPassesButton: false });
          }
        } else {
          this.setState({ disableIssueBoardingPassesButton: true });
        }
      } else {
        this.setState({ disableIssueBoardingPassesButton: true });
      }
    });
  }

  handleChangeOfInputTicketVehiclePhone(event, index) {
    let ticketVehiclePhoneNumbers = [...this.state.ticketVehiclePhoneNumbers];
    let item = { ...ticketVehiclePhoneNumbers[index] };
    item = event.target.value;
    if (/^[0-9\b]+$/.test(item) || item.length === 0)
      ticketVehiclePhoneNumbers[index] = item;
    this.setState({ ticketVehiclePhoneNumbers }, () => {
      let hasSelectedPersons = false;
      let shouldNotIssueBoardingPassesFlag1 = false;
      for (let i = 0; i < this.state.selectedPersonTickets.length; i++) {
        if (this.state.selectedPersonTickets[i] === true) {
          hasSelectedPersons = true;
          if (
            (this.state.ticketEmails[i] === "" &&
              this.state.ticketPhoneNumbers[i] === "") ||
            ((this.state.ticketEmails[i].length > 0 &&
              !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                this.state.ticketEmails[i]
              )) ||
              (this.state.ticketPhoneNumbers[i].length > 0 &&
                this.state.ticketPhoneNumbers[i].length < 10))
          )
            shouldNotIssueBoardingPassesFlag1 = true;
        }
      }
      let shouldNotIssueBoardingPassesFlag2 = false;
      let hasSelectedVehicles = false;
      for (let i = 0; i < this.state.selectedVehicleTickets.length; i++) {
        if (this.state.selectedVehicleTickets[i] === true) {
          hasSelectedVehicles = true;
          if (
            (this.state.ticketVehicleEmails[i] === "" &&
              this.state.ticketVehiclePhoneNumbers[i] === "") ||
            ((this.state.ticketVehicleEmails[i].length > 0 &&
              !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                this.state.ticketVehicleEmails[i]
              )) ||
              (this.state.ticketVehiclePhoneNumbers[i].length > 0 &&
                this.state.ticketVehiclePhoneNumbers[i].length < 10))
          )
            shouldNotIssueBoardingPassesFlag2 = true;
        }
      }

      if (hasSelectedPersons) {
        if (!shouldNotIssueBoardingPassesFlag1) {
          if (hasSelectedVehicles) {
            if (!shouldNotIssueBoardingPassesFlag2) {
              this.setState({ userHasInsertedAllData: true });
              if (this.state.selectedItineraryID !== "")
                this.setState({ disableIssueBoardingPassesButton: false });
            } else {
              this.setState({ disableIssueBoardingPassesButton: true });
            }
          } else {
            this.setState({ userHasInsertedAllData: true });
            if (this.state.selectedItineraryID !== "")
              this.setState({ disableIssueBoardingPassesButton: false });
          }
        } else {
          this.setState({ disableIssueBoardingPassesButton: true });
        }
      } else if (hasSelectedVehicles) {
        if (!shouldNotIssueBoardingPassesFlag2) {
          if (hasSelectedPersons) {
            if (!shouldNotIssueBoardingPassesFlag1) {
              this.setState({ userHasInsertedAllData: true });
              if (this.state.selectedItineraryID !== "")
                this.setState({ disableIssueBoardingPassesButton: false });
            } else {
              this.setState({ disableIssueBoardingPassesButton: true });
            }
          } else {
            this.setState({ userHasInsertedAllData: true });
            if (this.state.selectedItineraryID !== "")
              this.setState({ disableIssueBoardingPassesButton: false });
          }
        } else {
          this.setState({ disableIssueBoardingPassesButton: true });
        }
      } else {
        this.setState({ disableIssueBoardingPassesButton: true });
      }
    });
  }

  handlePersonCheckboxChange(index) {
    let selectedPersonTickets = [...this.state.selectedPersonTickets];
    let item = { ...selectedPersonTickets[index] };
    item = !this.state.selectedPersonTickets[index];
    selectedPersonTickets[index] = item;
    this.setState({ selectedPersonTickets }, () => {
      let hasSelectedPersons = false;
      let shouldNotIssueBoardingPassesFlag1 = false;
      for (let i = 0; i < this.state.selectedPersonTickets.length; i++) {
        if (this.state.selectedPersonTickets[i] === true) {
          hasSelectedPersons = true;
          if (
            (this.state.ticketEmails[i] === "" &&
              this.state.ticketPhoneNumbers[i] === "") ||
            ((this.state.ticketEmails[i].length > 0 &&
              !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                this.state.ticketEmails[i]
              )) ||
              (this.state.ticketPhoneNumbers[i].length > 0 &&
                this.state.ticketPhoneNumbers[i].length < 10))
          )
            shouldNotIssueBoardingPassesFlag1 = true;
        }
      }
      let shouldNotIssueBoardingPassesFlag2 = false;
      let hasSelectedVehicles = false;
      for (let i = 0; i < this.state.selectedVehicleTickets.length; i++) {
        if (this.state.selectedVehicleTickets[i] === true) {
          hasSelectedVehicles = true;
          if (
            (this.state.ticketVehicleEmails[i] === "" &&
              this.state.ticketVehiclePhoneNumbers[i] === "") ||
            ((this.state.ticketVehicleEmails[i].length > 0 &&
              !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                this.state.ticketVehicleEmails[i]
              )) ||
              (this.state.ticketVehiclePhoneNumbers[i].length > 0 &&
                this.state.ticketVehiclePhoneNumbers[i].length < 10))
          )
            shouldNotIssueBoardingPassesFlag2 = true;
        }
      }

      if (hasSelectedPersons) {
        if (!shouldNotIssueBoardingPassesFlag1) {
          if (hasSelectedVehicles) {
            if (!shouldNotIssueBoardingPassesFlag2) {
              this.setState({ userHasInsertedAllData: true });
              if (this.state.selectedItineraryID !== "")
                this.setState({ disableIssueBoardingPassesButton: false });
            } else {
              this.setState({ disableIssueBoardingPassesButton: true });
            }
          } else {
            this.setState({ userHasInsertedAllData: true });
            if (this.state.selectedItineraryID !== "")
              this.setState({ disableIssueBoardingPassesButton: false });
          }
        } else {
          this.setState({ disableIssueBoardingPassesButton: true });
        }
      } else if (hasSelectedVehicles) {
        if (!shouldNotIssueBoardingPassesFlag2) {
          if (hasSelectedPersons) {
            if (!shouldNotIssueBoardingPassesFlag1) {
              this.setState({ userHasInsertedAllData: true });
              if (this.state.selectedItineraryID !== "")
                this.setState({ disableIssueBoardingPassesButton: false });
            } else {
              this.setState({ disableIssueBoardingPassesButton: true });
            }
          } else {
            this.setState({ userHasInsertedAllData: true });
            if (this.state.selectedItineraryID !== "")
              this.setState({ disableIssueBoardingPassesButton: false });
          }
        } else {
          this.setState({ disableIssueBoardingPassesButton: true });
        }
      } else {
        this.setState({ disableIssueBoardingPassesButton: true });
      }
    });
  }

  handleVehicleCheckboxChange(index) {
    let selectedVehicleTickets = [...this.state.selectedVehicleTickets];
    let item = { ...selectedVehicleTickets[index] };
    item = !this.state.selectedVehicleTickets[index];
    selectedVehicleTickets[index] = item;
    this.setState({ selectedVehicleTickets }, () => {
      let hasSelectedPersons = false;
      let shouldNotIssueBoardingPassesFlag1 = false;
      for (let i = 0; i < this.state.selectedPersonTickets.length; i++) {
        if (this.state.selectedPersonTickets[i] === true) {
          hasSelectedPersons = true;
          if (
            (this.state.ticketEmails[i] === "" &&
              this.state.ticketPhoneNumbers[i] === "") ||
            ((this.state.ticketEmails[i].length > 0 &&
              !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                this.state.ticketEmails[i]
              )) ||
              (this.state.ticketPhoneNumbers[i].length > 0 &&
                this.state.ticketPhoneNumbers[i].length < 10))
          )
            shouldNotIssueBoardingPassesFlag1 = true;
        }
      }
      let shouldNotIssueBoardingPassesFlag2 = false;
      let hasSelectedVehicles = false;
      for (let i = 0; i < this.state.selectedVehicleTickets.length; i++) {
        if (this.state.selectedVehicleTickets[i] === true) {
          hasSelectedVehicles = true;
          if (
            (this.state.ticketVehicleEmails[i] === "" &&
              this.state.ticketVehiclePhoneNumbers[i] === "") ||
            ((this.state.ticketVehicleEmails[i].length > 0 &&
              !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                this.state.ticketVehicleEmails[i]
              )) ||
              (this.state.ticketVehiclePhoneNumbers[i].length > 0 &&
                this.state.ticketVehiclePhoneNumbers[i].length < 10))
          )
            shouldNotIssueBoardingPassesFlag2 = true;
        }
      }

      if (hasSelectedPersons) {
        if (!shouldNotIssueBoardingPassesFlag1) {
          if (hasSelectedVehicles) {
            if (!shouldNotIssueBoardingPassesFlag2) {
              this.setState({ userHasInsertedAllData: true });
              if (this.state.selectedItineraryID !== "")
                this.setState({ disableIssueBoardingPassesButton: false });
            } else {
              this.setState({ disableIssueBoardingPassesButton: true });
            }
          } else {
            this.setState({ userHasInsertedAllData: true });
            if (this.state.selectedItineraryID !== "")
              this.setState({ disableIssueBoardingPassesButton: false });
          }
        } else {
          this.setState({ disableIssueBoardingPassesButton: true });
        }
      } else if (hasSelectedVehicles) {
        if (!shouldNotIssueBoardingPassesFlag2) {
          if (hasSelectedPersons) {
            if (!shouldNotIssueBoardingPassesFlag1) {
              this.setState({ userHasInsertedAllData: true });
              if (this.state.selectedItineraryID !== "")
                this.setState({ disableIssueBoardingPassesButton: false });
            } else {
              this.setState({ disableIssueBoardingPassesButton: true });
            }
          } else {
            this.setState({ userHasInsertedAllData: true });
            if (this.state.selectedItineraryID !== "")
              this.setState({ disableIssueBoardingPassesButton: false });
          }
        } else {
          this.setState({ disableIssueBoardingPassesButton: true });
        }
      } else {
        this.setState({ disableIssueBoardingPassesButton: true });
      }
    });
  }

  handlePersonSelectAllButton() {
    let value = !this.state.isPersonSelectAllToggled,
      size = this.state.personTickets.length,
      array = new Array(size);
    for (let i = 0; i < size; i++) {
      if (this.state.personTickets[i].ConfirmationStatus === "Canceled") {
        array[i] = false;
      } else {
        array[i] = value;
      }
    }
    this.setState({ selectedPersonTickets: array });
    this.setState(
      {
        isPersonSelectAllToggled: !this.state.isPersonSelectAllToggled
      },
      () => {
        let hasSelectedPersons = false;
        let shouldNotIssueBoardingPassesFlag1 = false;
        for (let i = 0; i < this.state.selectedPersonTickets.length; i++) {
          if (this.state.selectedPersonTickets[i] === true) {
            hasSelectedPersons = true;
            if (
              (this.state.ticketEmails[i] === "" &&
                this.state.ticketPhoneNumbers[i] === "") ||
              ((this.state.ticketEmails[i].length > 0 &&
                !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                  this.state.ticketEmails[i]
                )) ||
                (this.state.ticketPhoneNumbers[i].length > 0 &&
                  this.state.ticketPhoneNumbers[i].length < 10))
            )
              shouldNotIssueBoardingPassesFlag1 = true;
          }
        }
        let shouldNotIssueBoardingPassesFlag2 = false;
        let hasSelectedVehicles = false;
        for (let i = 0; i < this.state.selectedVehicleTickets.length; i++) {
          if (this.state.selectedVehicleTickets[i] === true) {
            hasSelectedVehicles = true;
            if (
              (this.state.ticketVehicleEmails[i] === "" &&
                this.state.ticketVehiclePhoneNumbers[i] === "") ||
              ((this.state.ticketVehicleEmails[i].length > 0 &&
                !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                  this.state.ticketVehicleEmails[i]
                )) ||
                (this.state.ticketVehiclePhoneNumbers[i].length > 0 &&
                  this.state.ticketVehiclePhoneNumbers[i].length < 10))
            )
              shouldNotIssueBoardingPassesFlag2 = true;
          }
        }

        if (hasSelectedPersons) {
          if (!shouldNotIssueBoardingPassesFlag1) {
            if (hasSelectedVehicles) {
              if (!shouldNotIssueBoardingPassesFlag2) {
                this.setState({ userHasInsertedAllData: true });
                if (this.state.selectedItineraryID !== "")
                  this.setState({ disableIssueBoardingPassesButton: false });
              } else {
                this.setState({ disableIssueBoardingPassesButton: true });
              }
            } else {
              this.setState({ userHasInsertedAllData: true });
              if (this.state.selectedItineraryID !== "")
                this.setState({ disableIssueBoardingPassesButton: false });
            }
          } else {
            this.setState({ disableIssueBoardingPassesButton: true });
          }
        } else if (hasSelectedVehicles) {
          if (!shouldNotIssueBoardingPassesFlag2) {
            if (hasSelectedPersons) {
              if (!shouldNotIssueBoardingPassesFlag1) {
                this.setState({ userHasInsertedAllData: true });
                if (this.state.selectedItineraryID !== "")
                  this.setState({ disableIssueBoardingPassesButton: false });
              } else {
                this.setState({ disableIssueBoardingPassesButton: true });
              }
            } else {
              this.setState({ userHasInsertedAllData: true });
              if (this.state.selectedItineraryID !== "")
                this.setState({ disableIssueBoardingPassesButton: false });
            }
          } else {
            this.setState({ disableIssueBoardingPassesButton: true });
          }
        } else {
          this.setState({ disableIssueBoardingPassesButton: true });
        }
      }
    );
  }

  handleVehicleSelectAllButton() {
    let value = !this.state.isVehicleSelectAllToggled,
      size = this.state.vehicleTickets.length,
      array = new Array(size);
    for (let i = 0; i < size; i++) {
      if (this.state.vehicleTickets[i].ConfirmationStatus === "Canceled") {
        array[i] = false;
      } else {
        array[i] = value;
      }
    }
    this.setState({ selectedVehicleTickets: array });
    this.setState(
      {
        isVehicleSelectAllToggled: !this.state.isVehicleSelectAllToggled
      },
      () => {
        let hasSelectedPersons = false;
        let shouldNotIssueBoardingPassesFlag1 = false;
        for (let i = 0; i < this.state.selectedPersonTickets.length; i++) {
          if (this.state.selectedPersonTickets[i] === true) {
            hasSelectedPersons = true;
            if (
              (this.state.ticketEmails[i] === "" &&
                this.state.ticketPhoneNumbers[i] === "") ||
              ((this.state.ticketEmails[i].length > 0 &&
                !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                  this.state.ticketEmails[i]
                )) ||
                (this.state.ticketPhoneNumbers[i].length > 0 &&
                  this.state.ticketPhoneNumbers[i].length < 10))
            )
              shouldNotIssueBoardingPassesFlag1 = true;
          }
        }
        let shouldNotIssueBoardingPassesFlag2 = false;
        let hasSelectedVehicles = false;
        for (let i = 0; i < this.state.selectedVehicleTickets.length; i++) {
          if (this.state.selectedVehicleTickets[i] === true) {
            hasSelectedVehicles = true;
            if (
              (this.state.ticketVehicleEmails[i] === "" &&
                this.state.ticketVehiclePhoneNumbers[i] === "") ||
              ((this.state.ticketVehicleEmails[i].length > 0 &&
                !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                  this.state.ticketVehicleEmails[i]
                )) ||
                (this.state.ticketVehiclePhoneNumbers[i].length > 0 &&
                  this.state.ticketVehiclePhoneNumbers[i].length < 10))
            )
              shouldNotIssueBoardingPassesFlag2 = true;
          }
        }

        if (hasSelectedPersons) {
          if (!shouldNotIssueBoardingPassesFlag1) {
            if (hasSelectedVehicles) {
              if (!shouldNotIssueBoardingPassesFlag2) {
                this.setState({ userHasInsertedAllData: true });
                if (this.state.selectedItineraryID !== "")
                  this.setState({ disableIssueBoardingPassesButton: false });
              } else {
                this.setState({ disableIssueBoardingPassesButton: true });
              }
            } else {
              this.setState({ userHasInsertedAllData: true });
              if (this.state.selectedItineraryID !== "")
                this.setState({ disableIssueBoardingPassesButton: false });
            }
          } else {
            this.setState({ disableIssueBoardingPassesButton: true });
          }
        } else if (hasSelectedVehicles) {
          if (!shouldNotIssueBoardingPassesFlag2) {
            if (hasSelectedPersons) {
              if (!shouldNotIssueBoardingPassesFlag1) {
                this.setState({ userHasInsertedAllData: true });
                if (this.state.selectedItineraryID !== "")
                  this.setState({ disableIssueBoardingPassesButton: false });
              } else {
                this.setState({ disableIssueBoardingPassesButton: true });
              }
            } else {
              this.setState({ userHasInsertedAllData: true });
              if (this.state.selectedItineraryID !== "")
                this.setState({ disableIssueBoardingPassesButton: false });
            }
          } else {
            this.setState({ disableIssueBoardingPassesButton: true });
          }
        } else {
          this.setState({ disableIssueBoardingPassesButton: true });
        }
      }
    );
  }

  fetchReservation = () => {
    this.setState({ shouldResDetailsUpdate: false });
    this.setState({ selectedItineraryIndex: null });
    this.setState({ hasPersonVouchers: false });
    let headerData = {
      userGroupCode: this.state.credentials.userGroupCode,
      lang: this.props.lang,
      password: this.state.credentials.password,
      code: this.state.credentials.code,
      departureDate: this.state.date.format("YYYYMMDD"),
      companyAbbreviation: this.state.companyAbbreviation,
      reservationNumber: this.state.reservationNumber.trim(),
      ticketNumber: this.state.ticketNumber.trim()
    };
    this.setState({ loadingSpinner: true });

    axios
      .post(B2B_PROXY + "/Itineraryenquiryticket", headerData)
      .then(res => {
        if (res.data === "Invalid Surname/Plates") {
          ToastStore.error(
            translations[this.props.lang]["Invalid Surname / Plates"],
            5000
          );
          this.setState({ loadingSpinner: false });
          return;
        }

        let itineraries = res.data[0].map(obj => ({
          VesselIMO: obj.VesselIMO,
          VesselName: obj.VesselName,
          CompanyCode: obj.CompanyCode,
          CompanyDescription: obj.CompanyDescription,
          DeparturePortCode: obj.DeparturePortCode,
          DeparturePortDescription: obj.DeparturePortDescription,
          DepartureDate: obj.DepartureDate,
          DepartureTime: obj.DepartureTime,
          ArrivalPortCode: obj.ArrivalPortCode,
          ArrivalPortDescription: obj.ArrivalPortDescription,
          ArrivalDate: obj.ArrivalDate,
          ArrivalTime: obj.ArrivalTime,
          Status: obj.Status,
          ItineraryAttribute: obj.ItineraryAttribute,
          ItineraryID: obj.ItineraryID,
          SailID: obj.SailID,
          AvailablePassengers: obj.AvailablePassengers,
          AvailableVehicles: obj.AvailableVehicles,
          OccupiedPassengers: obj.OccupiedPassengers,
          OccupiedVehicles: obj.OccupiedVehicles,
          CheckedInPassengers: obj.CheckedInPassengers,
          CheckedInVehicles: obj.CheckedInVehicles,
          RemainderPassengers: obj.RemainderPassengers,
          RemainderVehicles: obj.RemainderVehicles,
          ActualDepartureDate: obj.ActualDepartureDate,
          ActualDepartureTime: obj.ActualDepartureTime,
          CallNum: obj.CallNum,
          ConfirmedPassengerCounter: obj.ConfirmedPassengerCounter,
          ConfirmedVehicleCounter: obj.ConfirmedVehicleCounter,
          ConfirmedPassengerRemaining: obj.ConfirmedPassengerRemaining,
          ConfirmedVehicleRemaining: obj.ConfirmedVehicleRemaining,
          ConfirmedPassengerRemainingThreshold:
            obj.ConfirmedPassengerRemainingThreshold,
          ConfirmedVehicleRemainingThreshold:
            obj.ConfirmedVehicleRemainingThreshold,
          PaxAvailabilityStatusColor: obj.PaxAvailabilityStatusColor,
          VehAvailabilityStatusColor: obj.VehAvailabilityStatusColor
        }));

        this.setState({ itineraries });

        let personTickets = res.data[1].map(obj => ({
          Surname: obj.Surname,
          ItineraryID: obj.ItineraryID,
          Name: obj.Name,
          MaidenName: obj.MaidenName,
          AgeCategory: obj.AgeCategory,
          Gender: obj.Gender,
          BirthDate: obj.BirthDate,
          BirthPlace: obj.BirthPlace,
          Nationality: obj.Nationality,
          DocType: obj.DocType,
          PassportNumber: obj.PassportNumber,
          PassportDelDate: obj.PassportDelDate,
          VisaNumber: obj.VisaNumber,
          Occupation: obj.Occupation,
          SpecialServicesReq: obj.SpecialServicesReq,
          AccommodationType: obj.AccommodationType,
          CabinSeatNumber: obj.CabinSeatNumber,
          Berth: obj.Berth,
          TicketNumber: obj.TicketNumber,
          InitialTicketIssuer: obj.InitialTicketIssuer,
          CountryOfUsualResidence: obj.CountryOfUsualResidence,
          GoingTo: obj.GoingTo,
          CommingFrom: obj.CommingFrom,
          AddressInMorocco: obj.AddressInMorocco,
          PhoneDuringStay: obj.PhoneDuringStay,
          MainReasonForVisit: obj.MainReasonForVisit,
          TicketIssueDate: obj.TicketIssueDate,
          TicketExpirationDate: obj.TicketExpirationDate,
          BookID: obj.BookID,
          BoardID: obj.BoardID,
          ConfirmationID:
            obj.ConfirmationID === undefined ? "" : obj.ConfirmationID,
          BoardStatus: obj.BoardStatus,
          ConfirmationStatus: obj.ConfirmationStatus,
          Email: obj.Email === undefined ? "" : obj.Email,
          Mobile: obj.Mobile === undefined ? "" : obj.Mobile,
          IsMRZScanned: obj.IsMRZScanned,

        }));

        this.setState({ 
          personTickets: personTickets,
          isMRZMandatory: res.data[4] || "0"
        });

        let vehicleTickets = res.data[2].map(obj => ({
          ItineraryID: obj.ItineraryID,
          VehicleType: obj.VehicleType,
          Length: obj.Length,
          Height: obj.Height,
          RegistrationNumber: obj.RegistrationNumber,
          DriverName: obj.DriverName,
          Brand: obj.Brand,
          Model: obj.Model,
          TicketNumber: obj.TicketNumber,
          InitialTicketIssuer: obj.InitialTicketIssuer,
          TicketIssueDate: obj.TicketIssueDate,
          TicketExpirationDate: obj.TicketExpirationDate,
          BookID: obj.BookID,
          BoardID: obj.BoardID,
          ConfirmationID:
            obj.ConfirmationID === undefined ? "" : obj.ConfirmationID,
          BoardStatus: obj.BoardStatus,
          ConfirmationStatus: obj.ConfirmationStatus,
          Email: obj.Email === undefined ? "" : obj.Email,
          Mobile: obj.Mobile === undefined ? "" : obj.Mobile
        }));

        this.setState({ vehicleTickets: vehicleTickets });

        let tripData = res.data[3].map(obj => ({
          SailID: obj.SailID,
          ItineraryID: obj.ItineraryID,
          VesselIMO: obj.VesselIMO,
          VesselName: obj.VesselName,
          CompanyCode: obj.CompanyCode,
          CompanyDescription: obj.CompanyDescription,
          DeparturePortCode: obj.DeparturePortCode,
          DeparturePortDescription: obj.DeparturePortDescription,
          DepartureDate: obj.DepartureDate,
          DepartureTime: obj.DepartureTime,
          ArrivalPortCode: obj.ArrivalPortCode,
          ArrivalPortDescription: obj.ArrivalPortDescription,
          ArrivalDate: obj.ArrivalDate,
          ArrivalTime: obj.ArrivalTime
        }));

        this.setState({ tripData: tripData });

        let tripDataPersonSize = personTickets.length;
        let tripDataPersonArray = [];
        let tripDataVehicleArray = [];
        let i;
        for (i = 0; i < tripDataPersonSize; i++) {
          tripDataPersonArray.push(tripData[i]);
        }

        for (let j = i; j < tripData.length; j++) {
          tripDataVehicleArray.push(tripData[j]);
        }

        this.setState({ tripDataPerson: tripDataPersonArray }, () => {
          this.setState({ tripDataVehicle: tripDataVehicleArray });
          this.setState({ shouldResDetailsUpdate: true });
        });

        for (let i = 0; i < personTickets.length; i++) {
          let ticketEmails = [...this.state.ticketEmails];
          let item = { ...ticketEmails[i] };
          item = personTickets[i].Email;
          ticketEmails[i] = item;
          this.setState({ ticketEmails });
        }
        for (let i = 0; i < personTickets.length; i++) {
          let ticketPhoneNumbers = [...this.state.ticketPhoneNumbers];
          let item = { ...ticketPhoneNumbers[i] };
          item = personTickets[i].Mobile;
          ticketPhoneNumbers[i] = item;
          this.setState({ ticketPhoneNumbers });
        }
        for (let i = 0; i < vehicleTickets.length; i++) {
          let ticketVehicleEmails = [...this.state.ticketVehicleEmails];
          let item = { ...ticketVehicleEmails[i] };
          item = vehicleTickets[i].Email;
          ticketVehicleEmails[i] = item;
          this.setState({ ticketVehicleEmails });
        }
        for (let i = 0; i < vehicleTickets.length; i++) {
          let ticketVehiclePhoneNumbers = [
            ...this.state.ticketVehiclePhoneNumbers
          ];
          let item = { ...ticketVehiclePhoneNumbers[i] };
          item = vehicleTickets[i].Mobile;
          ticketVehiclePhoneNumbers[i] = item;
          this.setState({ ticketVehiclePhoneNumbers });
        }

        let value = false,
          size = personTickets.length,
          emptyFalseArray = Array.apply(null, { length: size }).map(function () {
            return value;
          });
        this.setState({ selectedPersonTickets: emptyFalseArray });
        size = vehicleTickets.length;
        emptyFalseArray = Array.apply(null, { length: size }).map(function () {
          return value;
        });
        this.setState({ selectedVehicleTickets: emptyFalseArray });
        this.setState({ displayReservationResults: true });
        this.setState({ displayItineraries: true });
        this.setState({ loadingSpinner: false });
        if (personTickets.length === 0 && vehicleTickets.length === 0) {
          this.setState({ displayReservationResults: false });
          this.setState({ displayItineraries: false });
          ToastStore.error(translations[this.props.lang]["No Data"], 5000);
        } else {
          if (personTickets.length !== 0) {
            window.scrollTo(0, this.myRef.current.offsetTop + 400);
          }
        }

        let firstNewTicketIndex = null;
        for (let i = 0; i < personTickets.length; i++) {
          firstNewTicketIndex = i;
          break;
        }

        this.setState({ firstNewTicketIndex });
        this.setState({
          isPersonSelectAllToggled: false
        });
        this.setState({
          isVehicleSelectAllToggled: false
        });
        this.setState({
          disableIssueBoardingPassesButton: true
        });
      });
  };

  issueBoardingPassesAndConfirmOpenTickets = () => {
    this.setState({ loadingSpinner: true });
    this.setState({ hasPersonVouchers: false });
    let bookIDArray = [];
    let ticketNumberArray = [];
    let mobileArray = [];
    let emailArray = [];
    let bookIDVehicleArray = [];
    let ticketNumberVehicleArray = [];
    let mobileVehicleArray = [];
    let emailVehicleArray = [];

    for (let i = 0; i < this.state.personTickets.length; i++) {
      if (this.state.selectedPersonTickets[i]) {
        bookIDArray.push(this.state.personTickets[i].BookID);
        ticketNumberArray.push(this.state.personTickets[i].TicketNumber);
        mobileArray.push(this.state.ticketPhoneNumbers[i]);
        emailArray.push(this.state.ticketEmails[i]);
      }
    }

    for (let i = 0; i < this.state.vehicleTickets.length; i++) {
      if (this.state.selectedVehicleTickets[i]) {
        bookIDVehicleArray.push(this.state.vehicleTickets[i].BookID);
        ticketNumberVehicleArray.push(
          this.state.vehicleTickets[i].TicketNumber
        );
        mobileVehicleArray.push(this.state.ticketVehiclePhoneNumbers[i]);
        emailVehicleArray.push(this.state.ticketVehicleEmails[i]);
      }
    }

    axios
      .post(B2B_PROXY + "/confirmOpenTickets", {
        userGroupCode: this.state.credentials.userGroupCode,
        lang: this.state.credentials.lang,
        password: this.state.credentials.password,
        code: this.state.credentials.code,
        reservationNumber: this.state.reservationNumber,
        bookIDArray: bookIDArray,
        ticketNumberArray: ticketNumberArray,
        mobileArray: mobileArray,
        emailArray: emailArray,
        bookIDVehicleArray: bookIDVehicleArray,
        ticketNumberVehicleArray: ticketNumberVehicleArray,
        mobileVehicleArray: mobileVehicleArray,
        emailVehicleArray: emailVehicleArray,
        itineraryID: this.state.selectedItineraryID,
        sailID: this.state.selectedSailID
      })
      .then(res => {
        if (res.data.confirmCode === "000") {
          let tickets = [];
          let emails = [];
          let voucherArray = [];

          for (let i = 0; i < this.state.personTickets.length; i++) {
            if (this.state.selectedPersonTickets[i]) {
              emails.push({
                ConfirmationID: this.state.personTickets[i].ConfirmationID,
                EMAIL: this.state.ticketEmails[i]
              });
              tickets.push({ ticketemail: this.state.personTickets[i] });
              voucherArray.push(this.state.personTickets[i]);
              this.setState({ hasPersonVouchers: true });
            }
          }

          for (let i = 0; i < this.state.vehicleTickets.length; i++) {
            if (this.state.selectedVehicleTickets[i]) {
              emails.push({
                ConfirmationID: this.state.vehicleTickets[i].ConfirmationID,
                EMAIL: this.state.ticketVehicleEmails[i]
              });
              tickets.push({ ticketemail: this.state.vehicleTickets[i] });
              voucherArray.push(this.state.vehicleTickets[i]);
            }
          }
          this.setState({ vouchers: voucherArray });
          this.setState({ confirmationPDFArray: res.data.confirmationPDF });
          this.issueBoardingPasses();
        } else {
          ToastStore.error(res.data.StatusMessage, 5000);
          this.setState({ loadingSpinner: false });
        }
      });
  };

  confirmOpenTickets = () => {
    this.setState({ loadingSpinner: true });
    let bookIDArray = [];
    let ticketNumberArray = [];
    let mobileArray = [];
    let emailArray = [];
    let bookIDVehicleArray = [];
    let ticketNumberVehicleArray = [];
    let mobileVehicleArray = [];
    let emailVehicleArray = [];

    for (let i = 0; i < this.state.personTickets.length; i++) {
      if (this.state.selectedPersonTickets[i]) {
        bookIDArray.push(this.state.personTickets[i].BookID);
        ticketNumberArray.push(this.state.personTickets[i].TicketNumber);
        mobileArray.push(this.state.ticketPhoneNumbers[i]);
        emailArray.push(this.state.ticketEmails[i]);
      }
    }

    for (let i = 0; i < this.state.vehicleTickets.length; i++) {
      if (this.state.selectedVehicleTickets[i]) {
        bookIDVehicleArray.push(this.state.vehicleTickets[i].BookID);
        ticketNumberVehicleArray.push(
          this.state.vehicleTickets[i].TicketNumber
        );
        mobileVehicleArray.push(this.state.ticketVehiclePhoneNumbers[i]);
        emailVehicleArray.push(this.state.ticketVehicleEmails[i]);
      }
    }

    axios
      .post(B2B_PROXY + "/confirmOpenTickets", {
        userGroupCode: this.state.credentials.userGroupCode,
        lang: this.state.credentials.lang,
        password: this.state.credentials.password,
        code: this.state.credentials.code,
        reservationNumber: this.state.reservationNumber,
        bookIDArray: bookIDArray,
        ticketNumberArray: ticketNumberArray,
        mobileArray: mobileArray,
        emailArray: emailArray,
        bookIDVehicleArray: bookIDVehicleArray,
        ticketNumberVehicleArray: ticketNumberVehicleArray,
        mobileVehicleArray: mobileVehicleArray,
        emailVehicleArray: emailVehicleArray,
        itineraryID: this.state.selectedItineraryID,
        sailID: this.state.selectedSailID
      })
      .then(res => {
        this.setState({ loadingSpinner: false });
        if (res.data.confirmCode === "000") {
          this.setState({ displayReservationResults: false });
          this.setState({ showSearchContainer: false });
          this.setState({ displayItineraries: false });
          this.setState({ displayVouchersConfirmed: true });
          window.scrollTo(0, this.jumpToTop.current.offsetTop);
          ToastStore.success(
            translations[this.props.lang][
            "You have successfully confirmed your tickets."
            ],
            5000
          );
          this.confirmTicketsResult(res.data.ConfirmationIDs);
          this.setState({ confirmationPDFArray: res.data.confirmationPDF });
        } else {
          ToastStore.error(res.data.StatusMessage, 5000);
        }
      });
  };

  confirmTicketsResult = ConfirmationIDs => {
    this.setState({ loadingSpinner: true });
    this.setState({ hasPersonVouchers: false });
    let tickets = [];
    let emails = [];
    let voucherArray = [];

    for (let i = 0; i < this.state.personTickets.length; i++) {
      if (this.state.selectedPersonTickets[i]) {
        emails.push({
          ConfirmationID: this.state.personTickets[i].ConfirmationID,
          EMAIL: this.state.ticketEmails[i],
          TicketNumber: this.state.personTickets[i].TicketNumber
        });
        tickets.push({ ticketemail: this.state.personTickets[i] });
        voucherArray.push(this.state.personTickets[i]);
        this.setState({ hasPersonVouchers: true });
      }
    }

    for (let i = 0; i < this.state.vehicleTickets.length; i++) {
      if (this.state.selectedVehicleTickets[i]) {
        emails.push({
          ConfirmationID: this.state.vehicleTickets[i].ConfirmationID,
          EMAIL: this.state.ticketVehicleEmails[i],
          TicketNumber: this.state.vehicleTickets[i].TicketNumber
        });
        tickets.push({ ticketemail: this.state.vehicleTickets[i] });
        voucherArray.push(this.state.vehicleTickets[i]);
      }
    }
    this.setState({ vouchers: voucherArray });
    this.setState({ loadingSpinner: false });
  };

  cancelOpenTickets = () => {
    this.setState({ loadingSpinner: true });
    this.setState({ hasPersonVouchers: false });
    let bookIDArray = [];
    let mobileArray = [];
    let emailArray = [];
    let bookIDVehicleArray = [];
    let mobileVehicleArray = [];
    let emailVehicleArray = [];
    let voucherArray = [];

    for (let i = 0; i < this.state.personTickets.length; i++) {
      if (this.state.selectedPersonTickets[i]) {
        bookIDArray.push(this.state.personTickets[i].BookID);
        mobileArray.push(this.state.ticketPhoneNumbers[i]);
        emailArray.push(this.state.ticketEmails[i]);
        voucherArray.push(this.state.personTickets[i]);
        this.setState({ hasPersonVouchers: true });
      }
    }

    for (let i = 0; i < this.state.vehicleTickets.length; i++) {
      if (this.state.selectedVehicleTickets[i]) {
        bookIDVehicleArray.push(this.state.vehicleTickets[i].BookID);
        mobileVehicleArray.push(this.state.ticketVehiclePhoneNumbers[i]);
        emailVehicleArray.push(this.state.ticketVehicleEmails[i]);
        voucherArray.push(this.state.vehicleTickets[i]);
      }
    }

    this.setState({ boardingCardVouchers: voucherArray });
    axios
      .post(B2B_PROXY + "/cancelOpenTickets", {
        userGroupCode: this.state.credentials.userGroupCode,
        lang: this.state.credentials.lang,
        password: this.state.credentials.password,
        code: this.state.credentials.code,
        bookIDArray: bookIDArray,
        mobileArray: mobileArray,
        emailArray: emailArray,
        bookIDVehicleArray: bookIDVehicleArray,
        mobileVehicleArray: mobileVehicleArray,
        emailVehicleArray: emailVehicleArray,
        itineraryID: this.state.selectedItineraryID
      })
      .then(res => {
        this.setState({ loadingSpinner: false });
        if (res.data.confirmCode === "000") {
          this.setState({ displayReservationResults: false });
          this.setState({ showSearchContainer: false });
          this.setState({ displayItineraries: false });
          this.setState({ displayVouchers: true });
          this.setState({ hasCancelledTickets: true });
          window.scrollTo(0, this.jumpToTop.current.offsetTop);
          ToastStore.success(
            translations[this.props.lang][
            "You have successfully cancelled your tickets."
            ],
            5000
          );
        } else {
          ToastStore.error(res.data.StatusMessage, 5000);
        }
      });
  };

  issueBoardingPasses = () => {
    this.setState({ loadingSpinner: true });
    this.setState({ hasPersonVouchers: false });
    let tickets = [];
    let emails = [];
    let voucherArray = [];
    let bookIDArray = [];
    let firstVehicleIndex = null;

    for (let i = 0; i < this.state.personTickets.length; i++) {
      if (this.state.selectedPersonTickets[i]) {
        emails.push({
          BoardId: this.state.personTickets[i].BoardID,
          EMAIL: this.state.ticketEmails[i],
          TicketNumber: this.state.personTickets[i].TicketNumber
        });
        tickets.push({ ticketemail: this.state.personTickets[i] });
        voucherArray.push(this.state.personTickets[i]);
        bookIDArray.push(this.state.personTickets[i].BookID);
        this.setState({ hasPersonVouchers: true });

        if (this.state.isMRZMandatory === "1" && this.state.personTickets[i].IsMRZScanned !== "1") {
          ToastStore.error(
            translations[this.props.lang][
              "MRZ scanning is required. Please parse MRZ for the selected passengers."
            ] || "MRZ scanning is required. Please parse MRZ for the selected passengers.",
            5000
          );
          this.setState({ loadingSpinner: false });
          return;
        }
      }
    }

    if (emails.length > 0) {
      firstVehicleIndex = emails.length;
    } else {
      firstVehicleIndex = 0;
    }

    for (let i = 0; i < this.state.vehicleTickets.length; i++) {
      if (this.state.selectedVehicleTickets[i]) {
        emails.push({
          BoardId: this.state.vehicleTickets[i].BoardID,
          EMAIL: this.state.ticketVehicleEmails[i],
          TicketNumber: this.state.vehicleTickets[i].TicketNumber
        });
        tickets.push({ ticketemail: this.state.vehicleTickets[i] });
        voucherArray.push(this.state.vehicleTickets[i]);
        bookIDArray.push(this.state.vehicleTickets[i].BookID);
      }
    }



    this.setState({ boardingCardVouchers: voucherArray });
    axios
      .post(B2B_PROXY + "/checkin", {
        ticket: tickets,
        ITINID: this.state.selectedItineraryID,
        emailperTick: emails,
        ITINER: this.state.itineraries[this.state.selectedItineraryIndex],
        pnr: this.state.reservationNumber,
        userid: this.state.credentials.userGroupCode,
        UserName: this.state.credentials.code,
        Password: this.state.credentials.password,
        bookIDArray: bookIDArray,
        lang: this.props.lang,
        firstVehicleIndex: firstVehicleIndex
      })
      .then(res => {
        this.setState({ loadingSpinner: false });
        if (res.data.statusCode === "000") {
          this.setState({ displayReservationResults: false });
          this.setState({ showSearchContainer: false });
          this.setState({ displayItineraries: false });
          this.setState({ displayVouchers: true });
          this.setState({ displayVouchersConfirmed: true });
          window.scrollTo(0, this.jumpToTop.current.offsetTop);
          ToastStore.success(
            translations[this.props.lang][
            "Your Boarding Passes have been issued."
            ],
            5000
          );
          ToastStore.success(
            translations[this.props.lang][
            "You have successfully confirmed your tickets."
            ],
            5000
          );
        } else {
          ToastStore.error(res.data.StatusMessage, 5000);
        }
      });
  };

  changeTrip = () => {
    this.setState({ loadingSpinner: true });
    this.setState({ hasPersonVouchers: false });
    let bookIDArray = [];
    let ticketNumberArray = [];
    let mobileArray = [];
    let emailArray = [];
    let bookIDVehicleArray = [];
    let ticketNumberVehicleArray = [];
    let mobileVehicleArray = [];
    let emailVehicleArray = [];

    let tickets = [];
    let emails = [];
    let voucherArray = [];

    for (let i = 0; i < this.state.personTickets.length; i++) {
      if (this.state.selectedPersonTickets[i]) {
        emails.push({
          ConfirmationID: this.state.personTickets[i].ConfirmationID,
          EMAIL: this.state.ticketEmails[i],
          TicketNumber: this.state.personTickets[i].TicketNumber
        });
        tickets.push({ ticketemail: this.state.personTickets[i] });
        voucherArray.push(this.state.personTickets[i]);
      }
    }

    for (let i = 0; i < this.state.vehicleTickets.length; i++) {
      if (this.state.selectedVehicleTickets[i]) {
        emails.push({
          ConfirmationID: this.state.vehicleTickets[i].ConfirmationID,
          EMAIL: this.state.ticketVehicleEmails[i],
          TicketNumber: this.state.vehicleTickets[i].TicketNumber
        });
        tickets.push({ ticketemail: this.state.vehicleTickets[i] });
        voucherArray.push(this.state.vehicleTickets[i]);
      }
    }

    for (let i = 0; i < this.state.personTickets.length; i++) {
      if (this.state.selectedPersonTickets[i]) {
        bookIDArray.push(this.state.personTickets[i].BookID);
        ticketNumberArray.push(this.state.personTickets[i].TicketNumber);
        mobileArray.push(this.state.ticketPhoneNumbers[i]);
        emailArray.push(this.state.ticketEmails[i]);
        this.setState({ hasPersonVouchers: true });
      }
    }

    for (let i = 0; i < this.state.vehicleTickets.length; i++) {
      if (this.state.selectedVehicleTickets[i]) {
        bookIDVehicleArray.push(this.state.vehicleTickets[i].BookID);
        ticketNumberVehicleArray.push(
          this.state.vehicleTickets[i].TicketNumber
        );
        mobileVehicleArray.push(this.state.ticketVehiclePhoneNumbers[i]);
        emailVehicleArray.push(this.state.ticketVehicleEmails[i]);
      }
    }

    this.setState({ vouchers: voucherArray });

    axios
      .post(B2B_PROXY + "/changeTrip", {
        userGroupCode: this.state.credentials.userGroupCode,
        lang: this.state.credentials.lang,
        password: this.state.credentials.password,
        code: this.state.credentials.code,
        reservationNumber: this.state.reservationNumber,
        bookIDArray: bookIDArray,
        ticketNumberArray: ticketNumberArray,
        mobileArray: mobileArray,
        emailArray: emailArray,
        bookIDVehicleArray: bookIDVehicleArray,
        ticketNumberVehicleArray: ticketNumberVehicleArray,
        mobileVehicleArray: mobileVehicleArray,
        emailVehicleArray: emailVehicleArray,
        itineraryID: this.state.selectedItineraryID,
        sailID: this.state.selectedSailID,
        ticket: tickets,
        ITINID: this.state.selectedItineraryID,
        emailperTick: emails,
        ITINER: this.state.itineraries[this.state.selectedItineraryIndex],
        pnr: this.state.reservationNumber,
        userid: this.state.credentials.userGroupCode,
        UserName: this.state.credentials.code,
        Password: this.state.credentials.password
      })
      .then(res => {
        this.setState({ loadingSpinner: false });
        if (res.data.confirmCode === "000") {
          this.setState({ displayReservationResults: false });
          this.setState({ showSearchContainer: false });
          this.setState({ displayItineraries: false });
          this.setState({ displayVouchersConfirmed: true });
          this.setState({ confirmationPDFArray: res.data.confirmationPDF });
          window.scrollTo(0, this.jumpToTop.current.offsetTop);
          ToastStore.success(
            translations[this.props.lang][
            "You have successfully changed the trip of your tickets."
            ],
            5000
          );
        } else {
          ToastStore.error(res.data.StatusMessage, 5000);
        }
      });
  };

  goBackToFirstScreen = () => {
    window.location.href = "/confirm_tickets";
  };

  render() {
    return (
      <div className="container main">
        <Loader fullPage loading={this.state.loadingSpinner} />
        <ToastContainer
          store={ToastStore}
          className="toaster"
          lightBackground
          position={
            // @ts-ignore
            ToastContainer.POSITION.TOP_CENTER
          }
        />
        <SearchReservation
          date={this.state.date}
          companies={this.state.companies}
          companyDescription={this.state.companyDescription}
          fetchReservation={this.fetchReservation}
          displayVouchers={this.state.displayVouchers}
          lang={this.props.lang}
          reservationNumber={this.state.reservationNumber}
          ticketNumber={this.state.ticketNumber}
          disableSearchReservationButton={
            this.state.disableSearchReservationButton
          }
          showSearch={this.state.showSearchContainer}
          isCalendarOpen={this.state.isCalendarOpen}
          handleChangeOfDate={this.handleChangeOfDate}
          handleChangeOfInputSearchFields={this.handleChangeOfInputSearchFields}
          handleChangeOfCompany={this.handleChangeOfCompany}
          toggleCalendar={this.toggleCalendar}
        />
        <FetchItineraries
          displayItineraries={this.state.displayItineraries}
          lang={this.props.lang}
          itineraries={this.state.itineraries}
          handleClickOnItinerary={this.handleClickOnItinerary}
          selectedItineraryIndex={this.state.selectedItineraryIndex}
          myRef={this.myRef}
        />
        <ReservationDetails
          isMRZMandatory={this.state.isMRZMandatory}
          shouldResDetailsUpdate={this.state.shouldResDetailsUpdate}
          displayVouchers={this.state.displayVouchers}
          lang={this.props.lang}
          reservationNumber={this.state.reservationNumber}
          displayReservationResults={this.state.displayReservationResults}
          personTickets={this.state.personTickets}
          vehicleTickets={this.state.vehicleTickets}
          selectedPersonTickets={this.state.selectedPersonTickets}
          selectedVehicleTickets={this.state.selectedVehicleTickets}
          isPersonSelectAllToggled={this.state.isPersonSelectAllToggled}
          isVehicleSelectAllToggled={this.state.isVehicleSelectAllToggled}
          ticketEmails={this.state.ticketEmails}
          ticketPhoneNumbers={this.state.ticketPhoneNumbers}
          ticketVehicleEmails={this.state.ticketVehicleEmails}
          ticketVehiclePhoneNumbers={this.state.ticketVehiclePhoneNumbers}
          disableIssueBoardingPassesButton={
            this.state.disableIssueBoardingPassesButton
          }
          tripDataPerson={this.state.tripDataPerson}
          tripDataVehicle={this.state.tripDataVehicle}
          handlePersonCheckboxChange={this.handlePersonCheckboxChange}
          handleVehicleCheckboxChange={this.handleVehicleCheckboxChange}
          handlePersonSelectAllButton={this.handlePersonSelectAllButton}
          handleVehicleSelectAllButton={this.handleVehicleSelectAllButton}
          handleChangeOfInputTicketEmail={this.handleChangeOfInputTicketEmail}
          handleChangeOfInputTicketPhone={this.handleChangeOfInputTicketPhone}
          handleChangeOfInputTicketVehicleEmail={
            this.handleChangeOfInputTicketVehicleEmail
          }
          handleChangeOfInputTicketVehiclePhone={
            this.handleChangeOfInputTicketVehiclePhone
          }
          confirmOpenTickets={this.confirmOpenTickets}
          issueBoardingPassesAndConfirmOpenTickets={
            this.issueBoardingPassesAndConfirmOpenTickets
          }
          cancelOpenTickets={this.cancelOpenTickets}
          changeTrip={this.changeTrip}
          myRef={this.myRef}
        />
        <VoucherDisplay
          displayVouchers={this.state.displayVouchers}
          hasCancelledTickets={this.state.hasCancelledTickets}
          hasPersonVouchers={this.state.hasPersonVouchers}
          lang={this.props.lang}
          boardingCardVouchers={this.state.boardingCardVouchers}
          confirmationPDFArray={this.state.confirmationPDFArray}
          jumpToTop={this.jumpToTop}
          goBackToFirstScreen={this.goBackToFirstScreen}
        />
        <VoucherConfirm
          displayVouchers={this.state.displayVouchersConfirmed}
          hasPersonVouchers={this.state.hasPersonVouchers}
          lang={this.props.lang}
          vouchers={this.state.vouchers}
          confirmationPDFArray={this.state.confirmationPDFArray}
          jumpToTop={this.jumpToTop}
          goBackToFirstScreen={this.goBackToFirstScreen}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/ConfirmOpenTicket.js